module.exports = __webpack_public_path__ + "static/media/colorpicker2.2d3326cf.png";